import React from 'react'

import { LabelValueTable } from '@app/components'
import { LntDivider } from '@app/components/base'

import { VALUE_PLACEHOLDER } from '@app/constants/valuePlaceholder'

import { generateMonitoringDataTableItems, generatePricesDataTableItems } from './utils'

import styles from './styles.module.scss'

import type { MonitoringCharacteristicsProps } from './types'

export const MonitoringCharacteristics: React.FC<MonitoringCharacteristicsProps> = ({ data }) => {
  const monitoringData = generateMonitoringDataTableItems(data)
  const pricesData = generatePricesDataTableItems(data)

  return (
    <div className={ styles.monitoringCharacteristics }>
      <h5 className={ styles.monitoringCharacteristics__title }>Мониторинг</h5>
      <LabelValueTable
        data={ monitoringData }
        hasSeparator
        columns={ 2 }
      />

      <LntDivider type='horizontal' />

      <h5 className={ styles.monitoringCharacteristics__title }>Цена ленты</h5>
      <LabelValueTable
        data={ pricesData }
        hasSeparator
        columns={ 2 }
      />

      <LntDivider type='horizontal' />

      <h5 className={ styles.monitoringCharacteristics__title }>Как мониторить</h5>
      <p>{ data?.howToMonitor ?? VALUE_PLACEHOLDER.doubleDash }</p>
    </div>
  )
}
